module.exports = __webpack_public_path__ + "static/media/penicon.d30250af.svg";